/**
 * epgCard.tsx
 */
import Card from '@shared/types/props/card';
import EpgCardContainer from '@components/atoms/container/epgCardContainer';
import EpgCardTitle from '@components/atoms/text/epgCardTitle';
import useEpgCard from '../../lib/useEpgCard';
import { memo } from 'react';
import Event from '@shared/classes/event';

function EpgCard(parentProps: Card) {
  // Card hook
  const { props, ref } = useEpgCard(parentProps);
  // Render
  const available = (parentProps.item as Event)?.channel?.hasYouMissedIt();
  return props.container.width > 0 ? (
    <EpgCardContainer {...props.container} unavailable={!available} ref={ref}>
      <EpgCardTitle
        {...props.title}
        unavailable={!available && props.container.isPast}
      >
        {props.title.displayContent
          ? parentProps.item.title
          : parentProps.item.title.slice(0, 1)}
      </EpgCardTitle>
    </EpgCardContainer>
  ) : (
    <></>
  );
}

export default memo(EpgCard);
